import { useQuery } from '@tanstack/react-query'
import { fetchAdminHelpGaps, type HelpGapRow } from '../../api/help'
import { useActionToast } from '../../lib/useActionToast'

function formatWhen(iso: string) {
  try {
    return new Date(iso).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    })
  } catch {
    return iso
  }
}

export default function AdminHelpGapsScreen() {
  const { Toast } = useActionToast()
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['admin-help-gaps'],
    queryFn: fetchAdminHelpGaps,
    staleTime: 30_000,
  })

  const gaps: HelpGapRow[] = data ?? []

  return (
    <div className="admin-help-gaps" data-testid="admin-help-gaps-page">
      <header style={{ marginBottom: 24 }}>
        <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>Help gaps</h1>
        <p style={{ margin: '8px 0 0', color: 'var(--ink3)', fontSize: 14 }}>
          Questions Soren could not answer from the help library.
        </p>
      </header>

      {isLoading && <p>Loading…</p>}
      {isError && (
        <p>
          Could not load help gaps.{' '}
          <button type="button" className="btn" onClick={() => refetch()}>Retry</button>
        </p>
      )}

      {!isLoading && !isError && gaps.length === 0 && (
        <p data-testid="admin-help-gaps-empty">No unanswered questions logged yet.</p>
      )}

      {gaps.length > 0 && (
        <table className="admin-customers-table" data-testid="admin-help-gaps-table">
          <thead>
            <tr>
              <th>Question</th>
              <th>Count</th>
              <th>Last asked</th>
              <th>Route</th>
            </tr>
          </thead>
          <tbody>
            {gaps.map((row) => (
              <tr key={`${row.question}|${row.route || ''}`}>
                <td>{row.question}</td>
                <td>{row.count}</td>
                <td>{formatWhen(row.last_asked)}</td>
                <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{row.route || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {Toast}
    </div>
  )
}
